import api from './api'
import { EventoAuditoria } from '@/types/auditoria'
import { PageResponse } from '@/types/comum'

const BASE_URL = '/api/v1/auditoria'

/**
 * Filtros da consulta do consultor (Onda 8 / A17). De propósito NÃO existe
 * `usuarioId`/`tenant`: o ator é o `sub` do token e o tenant é o claim, ambos forçados
 * no repositório do backend — parâmetro do cliente seria ignorado de qualquer forma.
 */
export interface AuditoriaConsultorFiltros {
  /** ISO local (`YYYY-MM-DDTHH:mm:ss`), inclusivo. */
  inicio?: string
  fim?: string
  page?: number
  size?: number
}

const paramsDe = (filtros: AuditoriaConsultorFiltros): URLSearchParams => {
  const sp = new URLSearchParams()
  if (filtros.inicio) sp.append('inicio', filtros.inicio)
  if (filtros.fim) sp.append('fim', filtros.fim)
  return sp
}

/**
 * Consulta de auditoria do consultor: os mesmos endpoints do admin, com o escopo
 * (`usuario_id = sub`) decidido pelo backend. Serviço próprio e menor: sem filtros de
 * ator/tenant/módulo — a página do consultor não os expõe.
 */
export const auditoriaConsultorService = {
  listar: async (filtros: AuditoriaConsultorFiltros = {}): Promise<PageResponse<EventoAuditoria>> => {
    const sp = paramsDe(filtros)
    sp.append('page', String(filtros.page ?? 0))
    sp.append('size', String(filtros.size ?? 20))
    sp.append('sort', 'ocorridoEm,desc')
    const response = await api.get<PageResponse<EventoAuditoria>>(`${BASE_URL}?${sp.toString()}`)
    return response as unknown as PageResponse<EventoAuditoria>
  },

  /** Evento de outro ator responde 404 — a página trata como "não encontrado", não como proibido. */
  obter: async (id: string): Promise<EventoAuditoria> => {
    const response = await api.get<EventoAuditoria>(`${BASE_URL}/${id}`)
    return response as unknown as EventoAuditoria
  },

  exportarCsv: async (filtros: AuditoriaConsultorFiltros = {}): Promise<Blob> => {
    const sp = paramsDe(filtros)
    sp.append('limite', String(filtros.size ?? 10000))
    const response = await api.get(`${BASE_URL}/export.csv?${sp.toString()}`, {
      responseType: 'blob',
    })
    return response as unknown as Blob
  },
}
